// This waits for the integrationsManager to finish its setup process before the app can continue
export default async ({ $integrationsManager }) => {
    await $integrationsManager.init()
}
